var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicTipsGiFs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(97.96 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 52,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(97.96 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.04,
    width: 51,
    height: 39.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(97.96 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,27.51a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2H45a2,2,0,0,1,2,2V25.51a2,2,0,0,1-2,2H30.65l-3.5,4.72a2,2,0,0,1-2.8.42,2.09,2.09,0,0,1-.42-.42l-3.5-4.72Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 97.96,
    y: 3,
    width: 52,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAoCAYAAACxbNkLAAAACXBIWXMAAAsSAAALEgHS3X78AAACLElEQVRoQ+2Z0W7bMAxFDztv+/+/3Zo43IN1I4q2Erd1UAHzBQjVsQzziKQKU+buAJiZsdbWb98tX/0gCMDcPcIYFSL+PZI8jLI71BQmGvAWTNejyYFbMjczc3efSnTk/I9iUxkFNkKkYkRm4FoMChS0ERLQr2IRahQpIheqX03qCUgRmlhgfpdxRKCZxS8L1zdNiEBGTbcYpdFSTmkmMC24AZ6BYh3JRouQxs0an8KF0YLF3W4UvbFEyZI1E7JGAuip6+NI6XSITqDRdQKNrhNodJ1Ao+sEGl0n0Oj6L4BWfa8B1fVRH0xZTeNhIEWfNn3UJ7hu5H7XnB94IOuMW/LO+ExqYakx0gXS5BtLE+JC7arsqbMIEb/ztxosek8c471HUpPkSgXbbGNlGKWi2kV7PstjLyI3WPR8jPwcrp+BQHV6ZvHxQhspYBvIqCshB/dIc6diP8uo5+M7tHBXOqnTkRbgGqwFcncvvfp7s462O7k3Okbb15PUWdIiXYD3YlrlvUCxznMtAW0NCUhh3QsDa6DsnIAE84fPAUGdG+tw8/SBcjPme9QzOCO1ZYucZXEU9b/F3tlImQeKczyNd01Q6cpJRHfyE2lXzM9ppxSQIqMa+Eh0VoqHXZAilG9+ROEAcKZGM24ueUO4p9pX3puVU+7TCpsLtHURd85VMR8JAwcCBcWCdeqGkYv5UBDJDl6gfPic/yk3IEdHB14AJHVO1e96BQy8EOi79A/gayGMdet4BAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-96,27.51a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h39a2,2,0,0,1,2,2V25.51a2,2,0,0,1-2,2H-71.35l-3.5,4.72a2,2,0,0,1-2.8.42,2.09,2.09,0,0,1-.42-.42l-3.5-4.72Z",
    transform: "translate(97.96 3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97,
    width: 53,
    height: 41.04
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(113.09 20.65)"
  }, "GIFs")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTipsGiFs);
export default __webpack_public_path__ + "static/media/TopicTips_GIFs.78acb77b9861ef716999e629c7940291.svg";
export { ForwardRef as ReactComponent };